var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgNftSwap = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3389 4.81049C21.3392 4.61042 21.576 4.50464 21.7256 4.63763L27.7559 9.99799C27.8597 10.0903 27.8597 10.2523 27.7559 10.3447L21.7256 15.706C21.5759 15.8391 21.3389 15.7325 21.3389 15.5322V12.2607H3.92871C3.80051 12.2607 3.69629 12.1565 3.69629 12.0283V8.31439C3.69631 8.18621 3.80052 8.08197 3.92871 8.08197H21.3389V4.81049Z",
    stroke: "currentColor",
    strokeWidth: 1.39283
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6611 16.4674C10.6608 16.2673 10.424 16.1615 10.2744 16.2945L4.24414 21.6549C4.14027 21.7472 4.14031 21.9092 4.24414 22.0016L10.2744 27.3629C10.4241 27.496 10.6611 27.3894 10.6611 27.1891V23.9176H28.0713C28.1995 23.9176 28.3037 23.8134 28.3037 23.6852V19.9713C28.3037 19.8431 28.1995 19.7389 28.0713 19.7389H10.6611V16.4674Z",
    stroke: "currentColor",
    strokeWidth: 1.39283
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNftSwap);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nft-swap.65c6b1cfad071af9b921bf6e1659daf8.svg";